const objectLength = obj => Object.keys(obj).length;

export { objectLength };